<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="520"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="桌台名称">
            <a-input placeholder="如：A01" v-decorator.trim="['name', validatorRules.name]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属区域">
            <a-select placeholder="请选择区域" v-decorator="['areaId', validatorRules.areaId]">
              <a-select-option v-for="a in areas" :key="a.id" :value="a.id">{{ a.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="桌型">
            <a-select placeholder="请选择桌型（可不选）" allow-clear v-decorator="['tableTypeId']">
              <a-select-option v-for="t in types" :key="t.id" :value="t.id">
                {{ t.name }}（{{ t.minCapacity }}-{{ t.maxCapacity }}人）
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="可坐人数">
            <a-input-number style="width: 100%" :min="1" placeholder="默认 4 人" v-decorator="['capacity', { initialValue: 4 }]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { tableAdd, tableUpdate } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'DiningTableModal',
  mixins: [mixinDevice],
  props: {
    storeId: { type: Number, default: null },
    areas: { type: Array, default: () => [] },
    types: { type: Array, default: () => [] }
  },
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        name: {
          rules: [
            { required: true, message: '请输入桌台名称!' },
            { max: 30, message: '长度不能超过 30 个字符', trigger: 'blur' }
          ]
        },
        areaId: {
          rules: [
            { required: true, message: '请选择所属区域!' }
          ]
        }
      }
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'name', 'areaId', 'tableTypeId', 'capacity'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          // 后端契约：新增 POST /table?storeId（storeId 在 query）+ body；编辑 PUT /table/{id}
          const body = Object.assign({}, values, {
            tableTypeId: values.tableTypeId || null,
            capacity: values.capacity || 4
          })
          let obj
          if (!this.model.id) {
            obj = tableAdd(this.storeId, body)
          } else {
            obj = tableUpdate(this.model.id, body)
          }
          obj.then(res => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
</style>
